import { Box, Card } from '@mui/material';
import { styled } from '@mui/system';

import { getBlobUrl } from '@/src/utils/commonUtil';

export const Body = styled(Box)(() => ({
    position: 'relative',
    background: 'white',
}));

export const AgnesTalkBubble = styled(Box)(() => ({
    position: 'absolute',
    display: 'inline-block',
    width: 200,
    height: 101,
    padding: '1em',
    paddingTop: '10px',
    backgroundColor: '#485155',
    borderRadius: '60px',
    color: 'white',

    '& .MuiTypography-root': {
        fontSize: '12px',
    },
    '&::after': {
        content: '""',
        position: 'absolute',
        width: 0,
        height: 0,
        border: '12px solid',
    },
}));

export const AgnesTalk = styled(AgnesTalkBubble)(({ theme }) => ({
    top: -74,
    left: 35,
    textAlign: 'center',
    '@media (max-width: 901px)': {
        left: -150,
        margin: 'auto',
        right: 0,
    },
    '&::after': {
        content: '""',
        position: 'absolute',
        width: 0,
        height: 0,
        right: 116,
        top: 122,
        borderWidth: '22px 0px 24px 24px',
        borderColor: '#485155 #485155 transparent transparent',
        transform: 'translateY(-50%)',
    },
    '& .agnes-text': {
        fontSize: theme.spacing(3),
    },
    '& .agnes-logo-text': {
        fontSize: theme.spacing(10),
    },
}));

export const ListItemStyle = styled(Box)(({ theme }) => ({
    textAlign: 'left',
    fontFamily: 'Equip_Regular',
    color: 'black',
    '& .MuiListItem-root': {
        padding: '0',
    },

    '& .MuiListItemIcon-root': {
        color: '#EC6707',
        minWidth: '24px',
        svg: {
            height: '16px',
            width: '16px',
            position: 'absolute',
            top: '5px',
        },
    },
    '& .MuiListItemText-root': {
        '& .MuiTypography-root': {
            fontSize: theme.spacing(3.6),
        },
    },
    '& .nested-lists': {
        top: 0,
        left: '6px',
        marginBottom: theme.spacing(6),
    },
}));

export const NestedListItem = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(4),
    lineHeight: 1,
    '& .MuiListItemText-root': {
        '& .MuiTypography-root': {
            fontSize: theme.spacing(3.6),
        },
    },
    '&::before': {
        marginRight: theme.spacing(1),
    },
}));

const bgImageCard = getBlobUrl('NewslatterBgImage');

export const StyleCard = styled(Card)(({ theme }) => ({
    borderRadius: '0',
    '& .main-banner-img': {
        marginRight: '8px',
        width: '430px',
        position: 'relative',
        '@media (max-width: 1024px)': {
            width: '310px',
        },
        '@media(max-width: 767px)': {
            width: '200px',
            bottom: '20px',
            marginRight: 0,
        },
    },
    '& .grid-bg--image': {
        backgroundImage: `url(${bgImageCard})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        width: '100%',
        height: '100%',
        backgroundRepeat: 'no-repeat',
        '@media (max-width: 901px)': {
            backgroundImage: 'none',
            textAlign: 'center',
            marginTop: '-30px',
        },
        '& .list-container': {
            paddingBottom: theme.spacing(0),
            position: 'relative',
            top: -60,
            '@media (max-width: 1441px)': {
                paddingLeft: theme.spacing(16),
            },
            '@media (max-width: 901px)': {
                background: '#FEF4EE',
                padding: theme.spacing(4),
                borderRadius: '24px',
                top: 0,
            },
            '& .list-container-heading': {
                '@media (max-width: 901px)': {
                    marginBottom: '12px',
                },
                '@media(max-width: 767px)': {
                    fontSize: theme.spacing(4),
                },
            },
            '& .list-container-itmes': {
                '@media (max-width: 901px)': {
                    flexDirection: 'column',
                    margin: 'auto',
                },
            },
        },
    },
    '& .MuiCardContent-root': {
        padding: theme.spacing(0, 8, 4, 8),

        '& .MuiTypography-root': {
            '@media (max-width: 901px)': {
                width: '100%',
            },
        },
    },
    '@media (max-width: 1024px)': {
        margin: '6rem 1rem 2rem 1rem',
        borderRadius: '24px',
    },
    '@media (max-width: 767px)': {
        marginBottom: '5rem',
    },
}));

export const StyledContactFooter = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: 60,
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    height: '20vh',

    '@media (max-width: 901px)': {
        padding: theme.spacing(6),
    },
    '& .contact-us-center': {
        alignItems: 'flex-start',
    },
    '& .contact-us-right': {
        textAlign: 'right',
    },
    '& .contact-us-left': {
        width: '100%',
    },
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        gap: 0,
        height: 'auto',
        alignItems: 'center',

        '& .contact-us-center': {
            order: 1,
            '& .MuiBox-root': {
                '@media (max-width: 901px)': {
                    height: '160px',
                    marginBottom: '60px',
                },
                '@media(max-width: 767px)': {
                    marginBottom: 0,
                },
            },
            '& .contact-us-center-img': {
                position: 'absolute',
                top: '25%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                '@media (max-width: 901px)': {
                    height: '20px',
                },
                '& .contact-us-img': {
                    '@media (max-width: 767px)': {
                        width: '400px',
                        height: '100px',
                    },
                },
            },
        },
        '& .contact-us-left': {
            fontSize: theme.spacing(4),
            order: 2,
            marginTop: theme.spacing(0),
            textAlign: 'center',
        },
        '& .contact-us-right': {
            order: 3,
            marginTop: theme.spacing(8),
            fontSize: theme.spacing(4),
            textAlign: 'center',
        },
    },
    '@media (max-width: 1070px) and (min-width: 901px)': {
        position: 'relative',
        top: -40,
    },
}));
